export default __webpack_public_path__ + "static/media/right.b4e2808d.svg";